export default __webpack_public_path__ + "static/media/chest1.88119b5d.png";